import { overrideVuetifyTheme } from "../src/easy-ui/utils/vuetifyTheme";
import { copyToClipboard } from "../src/utils/clipboard";
import { LogTime } from "../src/log_time/utils/calendarLogTime";
import { openUrlInNewTab } from "../src/utils/safeNavigation";
import { domSanitize } from "../src/shared/utils/domSanitize";
import { fetchWithSessionCheck } from "../src/shared/utils/sessionExpiryRedirect";

window.EASY ||= {};
window.EASY.utils ||= {};
window.EASY.utils.moduleLoader ||= {};
window.EasyCalendar ||= {};
window.EasyCalendar.LogTime = LogTime;
window.EASY.utils.openUrlInNewTab = openUrlInNewTab;
window.EASY.utils.domSanitize = domSanitize;
window.EASY.utils.fetchWithSessionCheck = fetchWithSessionCheck;

window.EASY.utils.loadUpdateForm = async (...params) => {
  const { loadUpdateForm } = await import("../src/./utils/issue_show_update");
  window.EASY.utils.loadUpdateForm = loadUpdateForm;
  loadUpdateForm(...params);
};

window.EASY.utils.showUpdate = async (target, prefilledNote) => {
  const { showUpdate } = await import("../src/./utils/issue_show_update");
  window.EASY.utils.showUpdate = showUpdate;
  showUpdate(target, prefilledNote);
};

window.EASY.utils.addValidationForChangingPermissions = async () => {
  const { addValidationForChangingPermissions } = await import("../src/utils/roles");
  window.EASY.utils.addValidationForChangingPermissions = addValidationForChangingPermissions;
  addValidationForChangingPermissions();
};

window.EASY.utils.newJournal = async options => {
  const { newJournal } = await import("../src/utils/newJournal");
  window.EASY.utils.newJournal = newJournal;
  newJournal(options);
};

window.EASY.utils.moduleLoader.lazyLoad = async (loadCallback, elementId) => {
  const { moduleLoader } = await import("../src/utils/module_loader");
  window.EASY.utils.moduleLoader = moduleLoader;
  window.EASY.utils.moduleLoader.lazyLoad(loadCallback, elementId);
};

window.EASY.utils.moduleLoader.addModuleToLoadQueue = async (loadCallback, elementId, moduleId) => {
  const { moduleLoader } = await import("../src/utils/module_loader");
  window.EASY.utils.moduleLoader = moduleLoader;
  window.EASY.utils.moduleLoader.addModuleToLoadQueue(loadCallback, elementId, moduleId);
};

window.EASY.utils.moduleLoader.removeModuleFromLoadQueue = async options => {
  const { moduleLoader } = await import("../src/utils/module_loader");
  window.EASY.utils.moduleLoader = moduleLoader;
  window.EASY.utils.moduleLoader.removeModuleFromLoadQueue(options);
};

window.EASY.utils.toggleTheme = async (...params) => {
  const { toggleTheme } = await import("../src/utils/theme");
  window.EASY.utils.toggleTheme = toggleTheme;
  await toggleTheme(...params);
};

window.EASY.utils.toggleContrast = async (...params) => {
  const { toggleContrast } = await import("../src/utils/theme");
  window.EASY.utils.toggleContrast = toggleContrast;
  await toggleContrast(...params);
};

window.EASY.utils.selectElementText = async element => {
  const { selectElementText } = await import("../src/utils/text");
  window.EASY.utils.selectElementText = selectElementText;
  selectElementText(element);
};

window.EASY.utils.getCurrentTheme = async () => {
  const { getCurrentTheme } = await import("../src/utils/getCurrentTheme");
  window.EASY.utils.getCurrentTheme = getCurrentTheme;
  getCurrentTheme();
};

// is needed to execute it directly without async load js,
// because of safari problem with NotAllowedError
window.EASY.utils.copyToClipboard = copyToClipboard;

window.EASY.utils.logTimeValidation = async (hoursInputId, fromInputId, toInputId) => {
  const { LogTimeValidationUtils } = await import("../src/shared/utils/logTimeValidation");
  return new LogTimeValidationUtils(hoursInputId, fromInputId, toInputId);
};

overrideVuetifyTheme();

window.EASY.utils.initWarnLeavingUnsaved = async () => {
  const { initWarnLeavingUnsaved } = await import("../src/utils/warnLeavingUnsaved");
  window.EASY.utils.initWarnLeavingUnsaved = initWarnLeavingUnsaved;
  initWarnLeavingUnsaved();
};

window.EASY.utils.loadWarnLeavingUnsaved = async () => {
  const { default: warnLeavingUnsavedInstance } = await import("../src/utils/warnLeavingUnsaved");
  return warnLeavingUnsavedInstance;
};

window.EASY.utils.mountAndOpenToggleableHeading = async (contentSelector, event) => {
  const { mountAndOpenToggleableHeading } = await import("../src/utils/moduleToggleableInit");
  window.EASY.utils.mountAndOpenToggleableHeading = mountAndOpenToggleableHeading;
  mountAndOpenToggleableHeading(contentSelector, event);
};

window.EASY.utils.findAndFocusErrorElement = async (inputFieldPartialId, labelTextContent) => {
  const { findAndFocusErrorElement } = await import("../src/utils/focusOnErrorField");
  window.EASY.utils.findAndFocusErrorElement = findAndFocusErrorElement;
  findAndFocusErrorElement(inputFieldPartialId, labelTextContent);
};

window.EASY.utils.focusOnInfoMessage = async () => {
  const { focusOnInfoMessage } = await import("../src/utils/focusOnInfoMessage");
  window.EASY.utils.focusOnInfoMessage = focusOnInfoMessage;
  focusOnInfoMessage();
};

window.EASY.utils.toggleWebhookTypeFields = async uuid => {
  const { toggleWebhookTypeFields } = await import("../src/utils/toggleWebhookTypeFields");
  window.EASY.utils.toggleWebhookTypeFields = toggleWebhookTypeFields;
  toggleWebhookTypeFields(uuid);
};

window.EASY.utils.useUTMTimeOnForm = async (formId, utmParams) => {
  const { useUTMTimeOnForm } = await import("../src/shared/utils/utm");
  window.EASY.utils.useUTMTimeOnForm = useUTMTimeOnForm;
  useUTMTimeOnForm(formId, utmParams);
};

window.EASY.utils.initHighlighting = async () => {
  const { initHighlighting } = await import("../src/utils/easy_lazy_highlight");
  window.EASY.utils.initHighlighting = initHighlighting;
  await initHighlighting();
};

window.EASY.utils.isExternalHref = async href => {
  const { isExternalHref } = await import("../src/utils/externalLink");
  window.EASY.utils.isExternalHref = isExternalHref;
  return isExternalHref(href);
};

window.EASY.utils.sendUTMTrackingData = async utmParams => {
  if (!window.EASY?.trackingEnabled) return;

  const { sendUTMTrackingData } = await import("../src/utils/utm");
  window.EASY.utils.sendUTMTrackingData = sendUTMTrackingData;
  await sendUTMTrackingData(utmParams);
};

window.EASY.utils.registerHandyScroll = async () => {
  const { registerHandyScroll } = await import("../src/utils/handyScroll");
  window.EASY.utils.registerHandyScroll = registerHandyScroll;

  await registerHandyScroll();
};
